/**
 * Color themes for analysis feedback sections in module answer review.
 *
 * @module analysisSectionThemes
 */

export interface AnalysisSectionTheme {
  readonly labelClassName: string;
  readonly boxClassName: string;
}

/** Label + box colors per analysis criterion / block key. */
export const ANALYSIS_SECTION_THEMES: Record<string, AnalysisSectionTheme> = {
  task_fulfillment: {
    labelClassName: 'text-primary',
    boxClassName: 'border-primary/25 bg-primary/5',
  },
  pronunciation: {
    labelClassName: 'text-violet-600',
    boxClassName: 'border-violet-200/60 bg-violet-50/50',
  },
  grammar: {
    labelClassName: 'text-sky-700',
    boxClassName: 'border-sky-200/60 bg-sky-50/50',
  },
  structure: {
    labelClassName: 'text-emerald-700',
    boxClassName: 'border-emerald-200/60 bg-emerald-50/50',
  },
  spelling: {
    labelClassName: 'text-orange-700',
    boxClassName: 'border-orange-200/60 bg-orange-50/50',
  },
  fluency: {
    labelClassName: 'text-cyan-700',
    boxClassName: 'border-cyan-200/60 bg-cyan-50/50',
  },
  vocabulary: {
    labelClassName: 'text-fuchsia-700',
    boxClassName: 'border-fuchsia-200/60 bg-fuchsia-50/50',
  },
  register: {
    labelClassName: 'text-indigo-700',
    boxClassName: 'border-indigo-200/60 bg-indigo-50/50',
  },
  style: {
    labelClassName: 'text-purple-700',
    boxClassName: 'border-purple-200/60 bg-purple-50/50',
  },
  interaction: {
    labelClassName: 'text-rose-700',
    boxClassName: 'border-rose-200/60 bg-rose-50/50',
  },
  explanation: {
    labelClassName: 'text-amber-600',
    boxClassName: 'border-amber-100 bg-amber-50/50',
  },
  diagnostic: {
    labelClassName: 'text-rose-600',
    boxClassName: 'border-rose-100 bg-rose-50/50',
  },
};

const DEFAULT_THEME: AnalysisSectionTheme = {
  labelClassName: 'text-muted-foreground',
  boxClassName: 'border-border bg-muted/20',
};

/** Resolve theme for a criterion or analysis block; falls back to neutral gray. */
export function getAnalysisSectionTheme(key: string): AnalysisSectionTheme {
  return ANALYSIS_SECTION_THEMES[key] ?? DEFAULT_THEME;
}
